import React from 'react';
import { Skeleton } from 'antd';

import styles from './styles.module.scss';

export const CertificateCardSkeleton = (): React.ReactElement => {
  return (
    <article className={styles.card} aria-hidden="true">
      <div className={styles.imageWrap}>
        <Skeleton active paragraph={false} title={false} className={styles.skeletonImage} />
      </div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <Skeleton active title={{ width: '70%' }} paragraph={false} />
          <Skeleton active title={{ width: 60 }} paragraph={false} />
        </div>
        <div className={styles.savingsBlock}>
          <Skeleton active title={false} paragraph={{ rows: 3, width: '100%' }} />
        </div>
        <div className={styles.tags}>
          <Skeleton active title={{ width: 90 }} paragraph={false} />
          <Skeleton active title={{ width: 85 }} paragraph={false} />
        </div>
        <Skeleton active title={false} paragraph={{ rows: 1, width: '60%' }} />
        <div className={styles.footer}>
          <Skeleton active title={{ width: 120 }} paragraph={false} />
          <Skeleton active title={{ width: 120 }} paragraph={false} />
        </div>
      </div>
    </article>
  );
};
